// extracted by mini-css-extract-plugin
module.exports = {"root":"Root_root__3tSeF"};